<svg
viewbox="0 0 512 512"
fill="currentColor"
xmlns="http://www.w3.org/2000/svg">
<path
    d="M493.25 56.26L455.74 18.75C443.25 6.25 426.87 0 410.49 0C394.11 0
    377.73 6.25 365.23 18.74L12.85 371.12L0.150022 485.34C-1.44998 499.72
    9.88002 512 23.95 512C24.84 512 25.73 511.95 26.64 511.85L140.78
    499.24L493.26 146.76C518.25 121.77 518.25 81.25 493.25
    56.26V56.26ZM126.09 468.68L33.06 478.99L43.42 385.82L307.31
    121.93L390.08 204.7L126.09 468.68V468.68ZM470.63 124.14L412.7
    182.07L329.93 99.3L387.86 41.37C393.9 35.33 401.94 32 410.49 32C419.04
    32 427.07 35.33 433.12 41.37L470.63 78.88C483.1 91.36 483.1 111.66
    470.63 124.14Z" />
</svg>